(function () {
  document.addEventListener('DOMContentLoaded', init);

  function init() {
    const form = document.querySelector('[data-js-language-select-form]');
    if (!form) return;

    const countryInput = form.querySelector('[data-js-country-code]');
    const languageInput = form.querySelector('[data-js-language-select]');
    if (!countryInput || !languageInput) return;

    labelLanguageToggles();
    bindLanguageButtons(form, countryInput, languageInput);
  }

  function currentLanguage() {
    return (document.documentElement.lang || '').slice(0, 2).toLowerCase();
  }

  function labelLanguageToggles() {
    const language = currentLanguage();

    document.querySelectorAll('[data-popout]').forEach((popout) => {
      const options = popout.querySelectorAll('[data-popout-option-button]');
      if (!options.length) return;

      const toggle = popout.querySelector('[data-popout-toggle]');
      if (!toggle) return;

      const active = Array.from(options).find(function (option) {
        return (option.dataset.lang || '').toLowerCase() === language;
      });

      if (active) toggle.textContent = active.textContent.trim();
    });
  }

  function bindLanguageButtons(form, countryInput, languageInput) {
    const currentCountry = (countryInput.dataset.currentCountry || '').trim().toUpperCase();

    document.querySelectorAll('[data-popout-option-button]').forEach((button) => {
      button.addEventListener('click', function (event) {
        event.preventDefault();

        const language = (button.dataset.lang || '').trim();
        if (!language) return;

        countryInput.value = currentCountry;
        languageInput.value = language;
        setReturnTo(form, button.dataset.root || '/');
        form.submit();
      });
    });
  }

  function setReturnTo(form, targetRoot) {
    const returnTo = form.querySelector('[data-js-return-to]');
    if (returnTo) returnTo.value = buildPath(targetRoot);
  }

  function buildPath(targetRoot) {
    const currentRoot = trimTrailing(window.theme?.localization?.root_url || '/');
    const target = trimTrailing(targetRoot);
    let path = window.location.pathname;

    if (currentRoot && (path === currentRoot || path.startsWith(currentRoot + '/'))) {
      path = path.slice(currentRoot.length);
    }

    return (target + (path || '/') + window.location.search) || '/';
  }

  function trimTrailing(value) {
    return value === '/' ? '' : value.replace(/\/+$/, '');
  }
})();
